import React, { useState } from 'react';
import * as S from '../styles';
import { ModalBanner } from './modalBanner';

export function Banner() {
  const [openModal, setOpenModal] = useState(false);

  return (
    <S.BannerCard as="section" aria-labelledby="portal-banner-title">
      <S.DivBackground />
      <S.BannerContent>
        <S.BannerCopy>
          <S.StartMessageH1 id="portal-banner-title" fontSize="28px">
            Entre na rede do portal de informações
          </S.StartMessageH1>
          <S.StartMessageP textAlign="left" color="black">
            Suas consultas automáticas e em um instante! Mais eficiência nas
            análises cadastrais da sua empresa: basta se conectar com o portal
            de informações.
          </S.StartMessageP>
        </S.BannerCopy>
        <S.BannerButton
          onClick={() => setOpenModal(true)}
          type="primary"
          size="large"
        >
          Saiba mais
        </S.BannerButton>
      </S.BannerContent>
      <ModalBanner open={openModal} setOpen={setOpenModal} />
    </S.BannerCard>
  );
}
